import { render } from "./ClinicalHistoryForm.vue?vue&type=template&id=7c95745e&scoped=true"
import script from "./ClinicalHistoryForm.vue?vue&type=script&lang=js"
export * from "./ClinicalHistoryForm.vue?vue&type=script&lang=js"

import "./ClinicalHistoryForm.vue?vue&type=style&index=0&id=7c95745e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c95745e"]])

export default __exports__